import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileInput", "uploadContainer", "preview", "previewImage", "previewName", "placeholder", "dropzone"]

  connect() {
    // Listen for face cleared event
    this.boundHandleFaceCleared = this.handleFaceCleared.bind(this)
    window.addEventListener("faces-dropdown:faceCleared", this.boundHandleFaceCleared)
    
    // Listen for base photo reset event
    this.boundHandleBasePhotoReset = this.handleBasePhotoReset.bind(this)
    this.element.addEventListener("base-photo:reset", this.boundHandleBasePhotoReset)
  }

  disconnect() {
    window.removeEventListener("faces-dropdown:faceCleared", this.boundHandleFaceCleared)
    this.element.removeEventListener("base-photo:reset", this.boundHandleBasePhotoReset)
  }

  handleFaceSelected(event) {
    const { faceId, faceUrl, faceName } = event.detail
    
    // When a face is selected, disable and hide the file input
    this.fileInputTarget.value = ""
    this.fileInputTarget.required = false
    
    // Show the selected face image
    const img = new Image()
    img.onload = () => {
      // Set the image as a background with contain to show full image
      this.previewImageTarget.style.backgroundImage = `url('${faceUrl}')`
      this.previewImageTarget.style.backgroundSize = 'contain'
      this.previewImageTarget.style.backgroundPosition = 'center'
      this.previewImageTarget.style.backgroundRepeat = 'no-repeat'
      this.previewImageTarget.style.aspectRatio = `${img.width} / ${img.height}`
    }
    img.src = faceUrl
    
    this.previewNameTarget.textContent = faceName
    this.previewTarget.classList.remove("hidden")
    this.dropzoneTarget.classList.add("hidden")
  }

  handleFileSelected(event) {
    // When a file is selected, clear the face selection
    const faceDropdownEvent = new CustomEvent("faces-dropdown:reset", {
      bubbles: true,
      detail: {}
    })
    window.dispatchEvent(faceDropdownEvent)

    // Show the dropzone and make the file input required
    this.dropzoneTarget.classList.remove("hidden")
    this.fileInputTarget.required = true
    
    // Hide preview
    this.previewTarget.classList.add("hidden")
  }

  handleFaceCleared() {
    // Show the dropzone and make the file input required
    this.dropzoneTarget.classList.remove("hidden")
    this.fileInputTarget.required = true
    
    // Hide preview
    this.previewTarget.classList.add("hidden")
  }

  handleBasePhotoReset() {
    // Reset the placeholder display when base photo is reset
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.style.display = "flex"
    }
  }
} 